import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import PersonOutwardArrowsIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PersonOutwardArrows.js';
import ShieldWithCrossIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithCross.js';
import ShieldWithDollarSignIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithDollarSign.js';
// styles
import { ColStyled } from './styles';

const ITEMS = [
  {
    icon: ShieldWithDollarSignIcon,
    cardId: 'individual',
    cardHeading: 'Individuals',
    cardText:  <>
      Disability insurance for individuals can protect your ability to earn a living by replacing some of your income if you are too sick or injured to work&#8212;so you can focus on getting better without worrying about how the bills will get paid or dipping into your savings.
    </>,
    linkUrl: '/life-and-money/what-is-disability-insurance-and-how-much-do-i-need/',
  },
  {
    icon: ShieldWithCrossIcon,
    cardId: 'doctors-dentists',
    cardHeading: 'Doctors and Dentists',
    cardText: <>
      For people in the medical field&#8212;doctors, dentists, and medical students&#8212;disability insurance is especially important because you&#39;re not just protecting your income, you&#39;re protecting the investment you&#39;ve made in your career.
    </>,
    linkUrl: '/disability-insurance/physicians-and-dentists-disability-insurance/',
  },
  {
    icon: PersonOutwardArrowsIcon,
    cardId: 'business-owners',
    cardHeading: 'Business owners and employers',
    cardText:  <>
      Disability insurance can help cover your overhead expenses and keep your business running if an owner or another key person becomes too sick or injured to do their job. It&#39;s also a valuable benefit you can offer employees to help attract and retain top talent.
    </>,
    linkUrl: '/financial-planning/business-risk-management/',
  },
];

export default () => (
  <SectionContainer
    id='disability-insurance-product-callout-grouping'
    backgroundVariant='lightB'
    moduleName='product-callout-grouping-module'>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Typography
          component='h2'
          align='center'
          nextElement='graphic'>
          There are several types of disability insurance. Find the one that&#39;s right <WidowBlock>for you.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row>
      {(
        ITEMS.map((item, index) =>  (
          <ColStyled
            medium={6}
            large={4}
            disableBottomPadding={(index + 1) === ITEMS.length} // disable bottom padding on last item
            key={item.cardId}>
            <ProductCard
              icon={item.icon}
              backgroundVariant='lightA'
              cardId={`product-callout-disability-insurance-${item.cardId}`}
              cardHeading={item.cardHeading}
              cardText={item.cardText}
              linkId={`product-callout-disability-insurance-${item.cardId}-link`}
              linkText='See more'
              linkUrl={item.linkUrl}
            />
          </ColStyled>
        ),
        )
      )}
    </Row>
  </SectionContainer>
);
